(function () {
  const VARIANT_CLASSES = {
    v1: ['ig-checkout-plus-v1', 'intelligems-checkout-plus-v1', 'ig-redo-checkout-plus-v1'],
    v2: ['ig-checkout-plus-v2', 'intelligems-checkout-plus-v2', 'ig-redo-checkout-plus-v2'],
  };

  const SVG = {
    cube:
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M16 12.5L11 9.5L16 6.5L21 9.5V15L16 18V12.5Z"/><path d="M11 9.5V15L16 18"/><path d="M16 12.5456L21 9.51562"/><path d="M7 9H2"/><path d="M7 12H4"/><path d="M7 15H6"/></svg>',
    returns:
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M17.5026 6.03906H6.04004V17.5016H17.5026V6.03906Z"/><path d="M13.6812 6.03906H9.86035V9.85991H13.6812V6.03906Z"/><path d="M19.6801 3.48047C21.7625 5.54373 23.0424 8.40936 23.0424 11.5807C23.0424 17.9042 17.9034 23.0432 11.5799 23.0432C9.72678 23.0432 7.9883 22.6038 6.45996 21.8396"/><path d="M3.86234 20.0627C1.77998 17.9995 0.5 15.1338 0.5 11.9625C0.5 5.63904 5.63904 0.5 11.9625 0.5C13.8156 0.5 15.5541 0.939397 17.0825 1.70357"/><path d="M22.0878 3.93897L19.6807 3.48047"/><path d="M3.86221 20.0601L1.45508 19.6016"/></svg>',
    package:
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10.1411 17.6938H0.5V0.5H17.6938V7.51426"/><path d="M11.9627 6.23127L9.09708 4.32085L6.23145 6.23127V0.5H11.9627V6.23127Z"/><path d="M23.0433 13.4925V15.4029C23.0433 19.2237 22.0881 21.1341 18.2673 23.0446C14.4464 21.1341 13.4912 19.2237 13.4912 15.4029V13.4925C15.7264 13.4925 17.9616 11.8113 18.2482 11.6011L18.2673 11.582L18.2864 11.6011C18.5729 11.8113 20.8082 13.4925 23.0433 13.4925Z"/></svg>',
    portal:
      '<svg viewBox="0 0 17 24" aria-hidden="true"><path d="M10.062 17.3215V9.11226C10.062 8.05789 9.2072 7.20312 8.15283 7.20312C7.09847 7.20312 6.2437 8.05789 6.2437 9.11226V12.5462L1.63634 14.6234C0.973204 14.9227 0.511719 15.5897 0.511719 16.3645C0.511719 16.6149 0.559924 16.854 0.647554 17.0732L2.55669 21.846C2.83809 22.5495 3.526 23.0464 4.32998 23.0464H10.0574C10.8053 23.0464 11.4528 22.6163 11.766 21.99L13.6751 18.1717C13.8034 17.9151 13.8757 17.6255 13.8757 17.319C13.8757 16.694 13.5752 16.139 13.1109 15.7907L10.0574 13.5008"/><path d="M8.13672 0.5V2.40913"/><path d="M13.5365 2.73828L12.1865 4.08823"/><path d="M15.7734 8.13672H13.8643"/><path d="M2.40913 8.13672H0.5"/><path d="M4.08628 4.08823L2.73633 2.73828"/></svg>',
  };

  let syncTimer = null;

  function getVariantFromElement(element) {
    const explicit = element.getAttribute('data-ig-checkout-plus');
    if (explicit === 'v1' || explicit === 'v2') return explicit;

    for (const [variant, classNames] of Object.entries(VARIANT_CLASSES)) {
      if (classNames.some((className) => element.classList.contains(className))) return variant;
    }

    return null;
  }

  function getVariant(checkout) {
    let element = checkout;

    while (element) {
      const variant = getVariantFromElement(element);
      if (variant) return variant;
      if (element === document.documentElement) break;
      element = element.parentElement;
    }

    return null;
  }

  function trustItems(variant) {
    return variant === 'v2'
      ? [
          ['returns', 'Free returns & exchanges'],
          ['package', 'Package protection'],
          ['portal', 'Easy return portal'],
        ]
      : [['cube', 'Fast U.S. Shipping']];
  }

  function trustHtml(variant) {
    return trustItems(variant)
      .map(
        ([icon, text]) =>
          '<span class="ig-cp-trust-item">' +
          '<span class="ig-cp-trust-icon"><span class="ig-cp-trust-svg" data-ig-icon="' +
          icon +
          '">' +
          SVG[icon] +
          '</span></span>' +
          '<span>' +
          text +
          '</span></span>'
      )
      .join('');
  }

  function ensureTrust(checkout, variant) {
    let trust = checkout.querySelector(':scope > .ig-cp-trust');

    if (!trust) {
      trust = document.createElement('div');
      trust.className = 'ig-cp-trust';

      const dynamicButtons = checkout.querySelector('.cart-checkout__dynamic-buttons');
      checkout.insertBefore(trust, dynamicButtons || null);
    }

    const html = trustHtml(variant);
    if (trust.dataset.igCheckoutPlusVariant !== variant || trust.innerHTML !== html) {
      trust.dataset.igCheckoutPlusVariant = variant;
      trust.innerHTML = html;
    }
  }

  function restore(checkout) {
    checkout.classList.remove('ig-checkout-plus-trust', 'ig-checkout-plus-trust--v1', 'ig-checkout-plus-trust--v2');
    checkout.querySelectorAll(':scope > .ig-cp-trust').forEach((node) => node.remove());
  }

  function applyVariant(checkout, variant) {
    checkout.classList.add('ig-checkout-plus-trust');
    checkout.classList.toggle('ig-checkout-plus-trust--v1', variant === 'v1');
    checkout.classList.toggle('ig-checkout-plus-trust--v2', variant === 'v2');
    ensureTrust(checkout, variant);
  }

  function sync() {
    document.querySelectorAll('.cart-checkout').forEach((checkout) => {
      if (!checkout.querySelector('redo-shopify-toggle')) return;

      const variant = getVariant(checkout);
      if (!variant) {
        restore(checkout);
        return;
      }

      applyVariant(checkout, variant);
    });
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(sync, 80);
  }

  function start() {
    sync();

    const observer = new MutationObserver((mutations) => {
      const shouldSync = mutations.some((mutation) => {
        if (mutation.target && mutation.target.closest && mutation.target.closest('.ig-checkout-plus-trust')) {
          return false;
        }

        if (mutation.type === 'attributes') {
          const target = mutation.target;
          if (!target) return false;
          if (target === document.body || target === document.documentElement) return true;

          return (
            target.matches('.cart-checkout, [data-cart-checkout], [data-ig-checkout-plus], .cart__checkout, .drawer__footer') ||
            Boolean(target.querySelector && target.querySelector('.cart-checkout, redo-shopify-toggle, [data-cart-checkout]'))
          );
        }

        return Array.from(mutation.addedNodes).some((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return false;
          return (
            node.matches('.cart-checkout, redo-shopify-toggle, [data-cart-checkout]') ||
            Boolean(node.querySelector('.cart-checkout, redo-shopify-toggle, [data-cart-checkout]'))
          );
        });
      });

      if (shouldSync) scheduleSync();
    });

    observer.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-ig-checkout-plus'],
    });

    window.addEventListener('resize', scheduleSync);
    document.addEventListener('cart:refresh', scheduleSync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
